<template>
	<v-card>
		<v-card-title class="pb-0">
			<v-avatar size="38" class="mr-3">
				<v-icon color="white" small>
					fas fa-pills
				</v-icon>
			</v-avatar>
			<h3>Medicamentos</h3>
		</v-card-title>
		<v-card-text>
			<v-container fluid grid-list-lg>
				<v-layout wrap>
					<v-flex v-if="medicamentos.length === 0">
						Nenhum medicamento
					</v-flex>
					<v-flex v-else v-for="(medicamento, index) in medicamentos" :key="index" class="medicamento" md6>
						<MedicamentoCard disabled :estoque="estoque_medicamentos" :boxId="boxId" :assinatura="assinatura" :quantidadeAproveitamentoReceita="getAproveitamentoReceita(medicamento.id)"
							:medicamento="medicamento"
							:mostrar_excluir="false"
							:data_base_pausa="data_base_pausa" />
						<v-tooltip top v-if="!readOnly">
							<v-checkbox slot="activator" v-model="medicamento.conferido" :disabled="medicamento.salvando_conferido" @change="val => onChange(val, medicamento)" />
							<span>Medicamento conferido</span>
						</v-tooltip>
					</v-flex>
				</v-layout>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
import { isBoxBeforePicking } from '@Util/functions';

import MedicamentoCard from '@Componentes/medicamento/medicamento-card';
import { AssinaturaMedicamentoPresenter } from '@Presenter/assinatura-medicamento-presenter';
import { PacientePresenter } from '@Presenter/paciente-presenter';
import moment from 'moment';

export default {
	name: 'Medicamentos',
	components: { MedicamentoCard },
	props: {
		assinatura: {
			type: Object,
			required: true
		},
		boxId: {
			required: false,
			type: Number
		},
		medicamentos: {
			type: Array,
			required: true
		},
		medicamentosComAproveitamentoReceita: {
			required: false,
			type: Array
		},
		readOnly: {
			type: Boolean,
			required: false
		}
	},
	data: () => ({
		carrega_estoque: false,
		estoque_medicamentos: []
	}),
	created() {
		this.medicamentos.forEach(med => {
			this.$set(med, 'salvando_conferido', false);
		});
		if (this.assinatura) {
			this.carrega_estoque = true;
			PacientePresenter.estoque(this.assinatura.paciente_id, { assinatura_id: this.assinatura.id })
				.then(estoque => {
					this.estoque_medicamentos = estoque;
				})
				.catch(() => {
					this.estoque_medicamentos = [];
				})
				.finally(() => {
					this.carrega_estoque = false;
				});
		}
	},
	methods: {
		getAproveitamentoReceita(medicamentoId) {
			if (!this.medicamentosComAproveitamentoReceita.length)
				return 1; // Default cycles

			const medicamentoComAproveitamentoReceitaEncontrado = this.medicamentosComAproveitamentoReceita
				.find(medicamentoComAproveitamentoReceita => medicamentoComAproveitamentoReceita.medicineId === medicamentoId);

			if (!medicamentoComAproveitamentoReceitaEncontrado)
				return 1;

			return medicamentoComAproveitamentoReceitaEncontrado.totalCycles;
		},
		onChange(conferido, medicamento) {
			medicamento.salvando_conferido = true;
			AssinaturaMedicamentoPresenter.update({
				id: medicamento.id_assinatura_medicamento,
				conferido
			})
				.catch(() => {
					medicamento.conferido = !conferido;
				})
				.finally(() => {
					medicamento.salvando_conferido = false;
				});
		}
	},
	computed: {
		data_base_pausa() {
			let date;
			// verifica se box ja passou pelo picking
			const box = this.assinatura.boxes[0];
			const antesPicking = box && isBoxBeforePicking(box.status);

			if (antesPicking)
				date = moment(box.inicio, 'YYYY-MM-DD');
			else
				date = moment(this.assinatura.data_proxima_box, 'DD/MM/YYYY');

			return date;
		}
	}
};
</script>

<style lang="scss" scoped>
.container {
	padding: 0;
}

.v-card {
  ::v-deep .v-card {
    box-shadow: none !important;
  }
}

.medicamento {
	position: relative;

	::v-deep .v-input--checkbox {
		position: absolute;
		top: 0;
		right: 16px;
	}
}
</style>
